const commentItems = [
  {
    name: '吃瓜一线牵',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20circular%20avatar%20illustration%20with%20soft%20crimson%20gradient%2C%20minimalist%20geometric%20design%2C%20clean%20modern%20aesthetic%2C%20subtle%20texture%2C%20profile%20picture%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '2分钟前',
    content: '五一吃瓜网真的是我每天的快乐源泉！更新速度太快了，每次有大瓜都能在这里第一时间看到完整梳理，再也不用到处翻微博了。',
    likes: '326',
  },
  {
    name: '理性吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20golden%20amber%20abstract%20circular%20avatar%20illustration%20with%20minimalist%20design%2C%20soft%20gradient%20texture%2C%20clean%20modern%20profile%20picture%20style%2C%20subtle%20geometric%20pattern&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '18分钟前',
    content: '内容分类做得很清晰，想看什么类型的瓜直接点专题索引就行。而且不需要注册这点太良心了，打开就能看。',
    likes: '189',
  },
  {
    name: '八卦小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20crimson%20and%20rose%20abstract%20circular%20avatar%20illustration%20with%20soft%20gradient%2C%20minimalist%20modern%20profile%20style%2C%20clean%20geometric%20design%2C%20subtle%20warm%20texture&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '1小时前',
    content: '关注五一吃瓜网半年了，从明星恋情到综艺内幕，信息又快又全。每天早上第一件事就是打开看看有没有新瓜。',
    likes: '452',
  },
  {
    name: '深夜吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20amber%20toned%20abstract%20circular%20avatar%20illustration%2C%20minimalist%20geometric%20design%20with%20soft%20gradient%2C%20clean%20modern%20profile%20picture%20style%2C%20subtle%20pattern%20texture&width=80&height=80&seq=avatar-04&orientation=squarish',
    time: '3小时前',
    content: '手机端体验特别好，躺在床上刷瓜太舒服了。页面加载很快，卡片式布局看着也清爽，推荐给了好多朋友。',
    likes: '271',
  },
  {
    name: '资深瓜田守望者',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20circular%20avatar%20illustration%20with%20crimson%20and%20golden%20gradient%2C%20minimalist%20geometric%20design%2C%20clean%20modern%20profile%20style%2C%20soft%20texture%20overlay&width=80&height=80&seq=avatar-05&orientation=squarish',
    time: '5小时前',
    content: '吃瓜这么多年，五一吃瓜网是目前做得最专业的聚合平台。专题追踪做得特别好，事件来龙去脉一目了然。',
    likes: '518',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            瓜友热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            来自全国各地瓜友的真实使用感受和吃瓜体验分享
          </p>
        </div>

        <div className="space-y-4">
          {commentItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                      {item.name}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
                  <div className="flex items-center gap-4 mt-2.5">
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-thumb-up-line"></i>
                      {item.likes}
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-chat-1-line"></i>
                      回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}